'use client';

import { c as _c } from "react/compiler-runtime";
import { ClockIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useWakatimeStats } from '@/hooks/queries/stats.query';
export function CodingHours() {
  const $ = _c(15);
  const {
    data,
    isSuccess,
    isLoading,
    isError
  } = useWakatimeStats();
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ClockIcon className="size-4.5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("homepage.about-me.coding-hours");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex items-center gap-2">{t0}<h2 className="text-sm">{t1}</h2></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isSuccess && `${data.hours} hrs`;
  const t4 = isLoading && "--";
  let t5;
  if ($[5] !== isError || $[6] !== t) {
    t5 = isError && t("common.error");
    $[5] = isError;
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex grow items-center justify-center text-4xl font-semibold">{t3}{t4}{t5}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = <div className="flex flex-col gap-6 rounded-2xl p-4 shadow-feature-card lg:p-6">{t2}{t6}</div>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}